module.exports = __webpack_public_path__ + "static/media/webdesign-services-img57.ba7fa929.jpg";